import { useNavigate } from "react-router-dom";
import { MessageCircle, Mail, MapPin } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { BookingForm } from "./BookingForm";
import { InstallmentHint } from "./InstallmentHint";
import { WHATSAPP_URL, WHATSAPP_DISPLAY, EMAIL, CENTER } from "./data";

export const BookingAside = () => (
  <div className="space-y-4">
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="booking-whatsapp-link"
      className="group flex items-center gap-4 rounded-2xl bg-[#1B3B28] text-[#FCFBF7] p-5 hover:bg-[#3E6B48] transition-colors">
      <span className="grid place-items-center w-11 h-11 rounded-full bg-[#86C89B] text-[#0F2317]"><MessageCircle size={18} /></span>
      <span><span className="eyebrow text-[#86C89B] block">WhatsApp</span><span className="text-lg">{WHATSAPP_DISPLAY}</span></span>
    </a>
    <a href={`mailto:${EMAIL}`} data-testid="booking-email-link" className="flex items-center gap-4 rounded-2xl border border-[#1B3B28]/10 p-5 hover:bg-[#FCFBF7] transition-colors">
      <span className="grid place-items-center w-11 h-11 rounded-full bg-[#E6ECE4] text-[#1B3B28]"><Mail size={18} /></span>
      <span className="min-w-0"><span className="eyebrow text-[#526356] block">Email</span><span className="text-sm text-[#1B3B28]">{EMAIL.split("@")[0]}@<wbr />{EMAIL.split("@")[1]}</span></span>
    </a>
    <div className="flex items-center gap-4 rounded-2xl border border-[#1B3B28]/10 p-5">
      <span className="grid place-items-center w-11 h-11 rounded-full bg-[#E6ECE4] text-[#1B3B28]"><MapPin size={18} /></span>
      <span><span className="eyebrow text-[#526356] block">Dove</span><span className="text-sm text-[#1B3B28]">{CENTER}<br />Via della Pace 41, 40015 Galliera (BO)<br />Mar–Ven 9:00–18:00</span></span>
    </div>
  </div>
);


export const Booking = ({ symptoms, setSymptoms }) => {
  const navigate = useNavigate();
  return (
    <section id="prenota" className="relative py-28 sm:py-40 bg-[#F4F3EC]" data-testid="booking-section">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-12 gap-16 lg:gap-y-6 lg:grid-rows-[auto_1fr]">
        <div className="lg:col-span-4 lg:row-start-1">
          <SectionHead eyebrow="Prenota" lines={["Iniziamo", "con calma."]} intro="Scegli tra visita parodontale e igiene GBT, poi lascia i tuoi dati: ti richiameremo noi, senza impegno, per fissare il primo incontro." />
          <Reveal delay={0.2} className="mt-10"><BookingAside /></Reveal>
        </div>
        <Reveal className="lg:col-span-7 lg:col-start-6 lg:row-start-1 lg:row-span-2" delay={0.1}>
          <div className="rounded-[2rem] bg-[#FCFBF7] border border-[#1B3B28]/10 p-7 sm:p-12 shadow-[0_30px_80px_-40px_rgba(27,59,40,0.35)]">
            <BookingForm symptoms={symptoms} setSymptoms={setSymptoms} onDone={(d) => navigate(d.trattamento === "igiene_gbt" ? "/igiene-gbt" : "/prima-visita", { state: d })} />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:col-start-1 lg:row-start-2 self-start" delay={0.25}><InstallmentHint /></Reveal>
      </div>
    </section>
  );
};
